import { InteractiveResponseSnackbar } from './interactive-response-snackbars.style';

export function InteractiveResponseSelectAreaSnackbar() {
  return (
    <InteractiveResponseSnackbar>
      Now choose where it goes.
    </InteractiveResponseSnackbar>
  );
}

export function InteractiveResponseSelectItemSnackbar() {
  return (
    <InteractiveResponseSnackbar>
      Now choose one to put here.
    </InteractiveResponseSnackbar>
  );
}
